// removed by extract-text-webpack-plugin
module.exports = {"stateShape":"map-module__stateShape___1etRl","sydneyShape":"map-module__sydneyShape___24mR-","stateShadow":"map-module__stateShadow___APZsG","sydneyShadow":"map-module__sydneyShadow___3BcGr","nswButton":"map-module__nswButton___3kdK2","regionalButton":"map-module__regionalButton___3ZHjz","sydneyButton":"map-module__sydneyButton___3zAkh","noPointerEvents":"map-module__noPointerEvents___3L7je"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map/map.module.scss
// module id = 240
// module chunks = 0